
export const showNoSamil = (show = false) => ({
    type: 'SHOW_NO_SAMIL',
    showNoSamil: show
});

export const showInverters = (show = false) => ({
    type: 'SHOW_INVERTERS',
    showInverters: show
});

export const showGrouped = (show = false) => ({
    type: 'SHOW_GROUPED',
    showGrouped: show
});

export const showPeriod = (period = 'yesterday') => ({
    type: 'SHOW_PERIOD',
    showPeriod: period
});

const filtersReducerDefaultState = {
    showNoSamil: false,
    showInverters: false,
    showGrouped: false,
    showPeriod: 'yesterday'
};

export const clear = () => ({
    type: 'CLEAR',
    defaultFilter: filtersReducerDefaultState
});


// WEBPACK FOOTER //
// ./src/actions/filters.js